import {Locale} from "../../Providers/LocaleProvider";
import Box, {BoxProps} from "@mui/material/Box";
import React, {useEffect, useMemo, useState} from "react";
import {MenuItem, TextField} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {queryOptions as options, useQueryBar} from "../../Providers/QueryBar";
import {useLocation} from "react-router-dom";
import {useRole} from "../../Providers/Role";


export const SearchBox =
    <T extends React.ElementType, >(props: BoxProps<T>) => {

        const role = useRole()
        const queryOptions = useMemo<typeof options>(() => {
            if (role === 'accountant') {
                return options.filter(o => o.path !== '/service_providers')
            }
            return options;
        }, [role])

        const {option, setOption, q, setQ, optionActive} = useQueryBar()
        const location = useLocation()
        const [queryInput, setQueryInput] = useState(q)


        const [firstRun, setFirstRun] = useState(true)

        const selectedOption = useMemo(() => {
            const o = queryOptions.find(o => o?.path === option?.path)
            if (!o) {
                return option;
            }
            return null;
        }, [option, queryOptions])


        useEffect(() => {
            if (optionActive) {
                document.querySelector<HTMLInputElement>('.search-box input[name=q]')?.focus()
            }
        }, [option, optionActive])

        useEffect(() => {
            if (q !== queryInput) {
                setQueryInput(q || '')
            }
        }, [location])

        useEffect(() => {
            if (optionActive) {
                setQ(queryInput || undefined)
            }
        }, [optionActive, queryInput, setQ])

        const onSubmit: React.FormEventHandler = event => {
            event.preventDefault();
            setQ(queryInput || undefined);
        }

        return (!option && !queryOptions?.length) ? <></> : <Box {...props} component={"form"} onSubmit={onSubmit}>
            <TextField
                type={"search"}
                autoFocus
                size="small"
                name={"q"}
                label={<Locale>common.search</Locale>}
                value={queryInput}
                onChange={e => {
                    setQueryInput(e.currentTarget.value)
                }}
                InputProps={{
                    endAdornment: <InputAdornment position={"end"}>
                        <TextField
                            variant={"standard"}
                            InputProps={{
                                disableUnderline: true,
                            }}
                            value={option?.path}
                            onChange={(e) => {
                                setOption(queryOptions.find(o => o.path === e.target.value)!)
                            }}
                            select
                        >
                            {
                                selectedOption &&
                                <MenuItem value={option?.path}>{option?.label}</MenuItem>
                            }
                            {queryOptions.map(option =>
                                <MenuItem key={option.path} value={option.path}>{option.label}</MenuItem>
                            )}
                        </TextField>
                        <IconButton type={"submit"} color={"inherit"} size={"small"}><FontAwesomeIcon icon={faSearch}/></IconButton>
                    </InputAdornment>
                }}
            />
        </Box>
    }
